<template lang="pug">
  .vue__form-submitted(@click="toggle = !toggle")
    //authenticated && interestIs('Webinar') && webinarSpecifics.streamOpen
    div(v-if="authenticated && interestIs('Webinar') && webinarSpecifics.streamOpen")
      template(v-if="webinarSpecifics.preOpened")
        Lottie(class="mb-3" :options="lottieOptions" :width="50" :height="50" @animCreated="handleAnimation")

        h4 Задайте свой вопрос Автору перед вебинаром

        template(v-if="redirectUrl") Вы будете перенаправлены через несколько секунд...
        template(v-else)
          p Перейдите по ссылке

          BaseButton.vue__form-submitted-button(tag="a" :href="webinarSpecifics.streamUrl")
            | На страницу вебинара
            FaIcon(icon="arrow-right" class="fa-icon")
      template(v-else)
        IntersectSpy(@enter="$refs.webinarLottie.play()" @leave="$refs.webinarLottie.stop()" :threshold="[1, 0]")
          WebinarLottie(ref="webinarLottie")

        h4 Вебинар начался!

        template(v-if="redirectUrl") Вы будете перенаправлены через несколько секунд...
        template(v-else)
          p Для участия в вебинаре перейдите по ссылке

          BaseButton.vue__form-submitted-button(tag="a" :href="webinarSpecifics.streamUrl")
            | Смотреть
            FaIcon(icon="arrow-right" class="fa-icon")
    template(v-else)
      Lottie(class="mb-3" :options="lottieOptions" :width="50" :height="50" @animCreated="handleAnimation")

      h4 Регистрация успешно пройдена!

      p
        template(v-if="interestIs('OfflineEvents::Event')") В ближайшее время с Вами свяжутся для уточнения Ваших пожеланий и офомления участия.
        template(v-else-if="interestIs('Webinar')") Мы пришлем Вам письмо с напоминанием на почту перед началом вебинара.

      p(v-if="redirectUrl") Вы будете перенаправлены через несколько секунд...
      template(v-else)
        template(v-if="afterSubmittedUrl")
          BaseButton.vue__form-submitted-button(tag="a" :href="afterSubmittedUrl")
            template(v-if="interestIs('CoursePrefix')")
              template(v-if="afterSubmittedPaid")
                | В кабинет курса #{' '}
              template(v-else)
                | К оплате #{' '}
            template(v-else-if="interestIs('Webinars::Sets::Set') || interestIs('Webinars::ZoomWebinar') || interestIs('CustomProducts::CustomProduct')")
              | К заказу
              FaIcon(icon="arrow-right" class="fa-icon")
        BaseButton.vue__form-submitted-button(v-else tag="a" href="/")
          FaIcon(icon="arrow-left" class="fa-icon")
          | На главную
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import * as checkLottie from '../lottie/check.json';

  import WebinarLottie from './WebinarLottie';
  import IntersectSpy from 'vue-intersect';

  export default {
    components: {
      WebinarLottie,
      IntersectSpy,
    },

    computed: {
      ...mapState([
        'authenticated',
        'redirectUrl',
        'interestType',
        'afterSubmittedUrl',
        'afterSubmittedPaid',
        'webinarSpecifics',
      ]),

      ...mapGetters([
        'interestIs',
      ]),
    },

    data () {
      return {
        lottieOptions: {
          animationData: checkLottie.default,
          loop: false,
        },

        toggle: true,
      };
    },

    mounted () {
      if (this.redirectUrl) {
        this.redirectTimeout = setTimeout(() => window.location.href = this.redirectUrl, 3000);
      }
    },

    beforeDestroy () {
      clearTimeout(this.redirectTimeout);
    },

    methods: {
      handleAnimation (anim) {
        this.anim = anim;
        this.anim.setSpeed(0.8);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .vue__form-submitted {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    .fa-check-circle path {
      fill: limegreen;
    }

    h4 {
      margin-top: 10px;
      font-weight: 400;
      font-size: 20px;
    }

    p {
      font-size: 17px;
    }

    .vue__form-submitted-button {
      margin-top: 20px;

      .fa-arrow-left {
        margin-right: 4px;
      }

      .fa-arrow-right {
        margin-left: 4px;
      }
    }
  }
</style>
